module.exports = __webpack_public_path__ + "img/egem.72b99ce6.svg";